import type { MinMax } from '../../core/types/min-max.js';
import type { CategoryName } from '../types/xy-chart-internals.js';

export function isMinMaxDomain(
  domain: MinMax | Set<CategoryName>,
): domain is MinMax {
  return (
    domain !== null &&
    typeof domain === 'object' &&
    'min' in domain &&
    'max' in domain
  );
}

export function isCategoricalDomain(
  domain: MinMax | Set<CategoryName>,
): domain is Set<CategoryName> {
  return domain !== null && typeof domain === 'object' && domain instanceof Set;
}
